export const GET_PROJECTS_BY_PROJECT_ID_AUDIENCE_BUILDER_AUDIENCE =
  'getProjectsByProjectIdAudienceBuilderAudience';
export const GET_PROJECTS_BY_PROJECT_ID_SURVEY_CONFIGS = 'getProjectsByProjectIdSurveyConfigs';
export const GET_PROJECTS_BY_PROJECT_ID_SURVEY_CONFIGS_AND_SURVEY_CONFIG_ID_BLOCKS =
  'getProjectsByProjectIdSurveyConfigsAndSurveyConfigIdBlocks';
export const GET_PROJECTS_BY_PROJECT_ID_SURVEYS = 'getProjectsByProjectIdSurveys';
export const GET_PROJECTS_BY_PROJECT_ID_FIELDING_GROUP = 'getProjectsByProjectIdFieldingGroup';
export const GET_SURVEYCONFIGS_BY_SURVEY_CONFIG_ID_SHOWLOGICS =
  'getSurveyconfigsBySurveyConfigIdShowlogics';
export const GET_SURVEYCONFIGS_BY_SURVEY_CONFIG_ID_SHOWLOGICS_AND_ID =
  'getSurveyconfigsBySurveyConfigIdShowlogicsAndId';
export const GET_SURVEY_CONFIG_BLOCK_GROUPS = 'getSurveyConfigBlockGroups';
export const GET_FIELDING_GROUPS_BY_FIELDING_GROUP_ID_STEPS =
  'getFieldingGroupsByFieldingGroupIdSteps';
